module.exports = __webpack_public_path__ + "static/media/intro.d9c064f5.mp3";